<template>
    <div>
        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Suorganizator: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-suorganizator-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                >
                </skup-suorganizator-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
import SkupSuorganizatorForma from "./SkupSuorganizatorForma";
export default {
    name: "SkupKotizacijaDetails",
    components: {
        SkupSuorganizatorForma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.suorganizator_id,
            skup_id: this.$route.params.skup_id,
            skup: {},
            naziv: ''
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/suorganizatori',
                    name: 'Suorganizatori'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/suorganizatori/' + this.id,
                    name: 'Suorganizator: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv
            this.setBreadcrumbs()
        },

    },
    mounted() {
    }
}
</script>

<style scoped>

</style>
